import { useEffect, useState } from "react";
import axios from "axios";

const apiUrl = "https://elcobradorleague.com/api";

export const usePlayerArmyLeaderboard = (playerId, idleague) => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!idleague) {
      setLeaderboard([]);
      setLoading(false);
      return;
    }

    const controller = new AbortController();
    setLoading(true);
    setError(null);

    const fetchLeaderboard = async () => {
      try {
        let url = `${apiUrl}/api.php?endpoint=player_army_leaderboard&idleague=${idleague}`;
        if (playerId) {
          url += `&playerId=${playerId}`;
        }

        const res = await axios.get(url, {
          headers: {
          'X-API-TOKEN': process.env.REACT_APP_API_TOKEN
        },
          signal: controller.signal,
        });

        setLeaderboard(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        if (err.name !== "CanceledError") {
          setError(err);
          setLeaderboard([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
    return () => controller.abort();
  }, [playerId, idleague]);

  return { leaderboard, loading, error };
};
